export default class AuditEvent {
  /**
   * Create new audit event and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }

  /**
   * @return {Date}
   */
  get dateTimeUtc () {
    return this._dateTimeUtc
  }

  /**
   * @param {string} value
   */
  set dateTimeUtc (value) {
    this._dateTimeUtc = value ? new Date(value) : null
  }
}
